// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__23cJ7","addWidgetButton":"Header_addWidgetButton__1HAF0","dashboardTabs":"Header_dashboardTabs__1StO8","active":"Header_active__1JJ7g"};